import React from 'react';

const AdminContentPart = ({ children }) => {
    return <div>{children}</div>;
};

export default AdminContentPart;
